(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cardGalleryInit) return;
    window.__cardGalleryInit = true;

    var overlay = document.createElement('div');
    overlay.className = 'card-gallery-lightbox';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="card-gallery-lightbox__close" aria-label="Schliessen">&times;</button>' +
      '<button type="button" class="card-gallery-lightbox__nav card-gallery-lightbox__nav--prev" aria-label="Zurueck">&#8249;</button>' +
      '<figure class="card-gallery-lightbox__figure">' +
        '<img class="card-gallery-lightbox__img" src="" alt="">' +
        '<figcaption class="card-gallery-lightbox__caption"></figcaption>' +
      '</figure>' +
      '<button type="button" class="card-gallery-lightbox__nav card-gallery-lightbox__nav--next" aria-label="Weiter">&#8250;</button>';

    var imgEl, capEl, group = [], index = -1;

    function ready() {
      if (!document.body) { document.addEventListener('DOMContentLoaded', ready); return; }
      document.body.appendChild(overlay);
      imgEl = overlay.querySelector('.card-gallery-lightbox__img');
      capEl = overlay.querySelector('.card-gallery-lightbox__caption');
    }
    ready();

    function show(i) {
      if (!group.length) return;
      if (i < 0) i = group.length - 1;
      if (i >= group.length) i = 0;
      index = i;
      var el = group[i];
      imgEl.src = el.getAttribute('data-cg-full');
      imgEl.alt = el.getAttribute('data-cg-name') || '';
      capEl.textContent = el.getAttribute('data-cg-name') || '';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (imgEl) imgEl.src = '';
      group = [];
      index = -1;
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cg-full]');
      if (trigger) {
        e.preventDefault();
        var gallery = trigger.closest('.card-gallery');
        group = Array.prototype.slice.call(gallery.querySelectorAll('[data-cg-full]'));
        show(group.indexOf(trigger));
        return;
      }
      if (!overlay.classList.contains('is-open')) return;
      if (e.target === overlay || e.target.closest('.card-gallery-lightbox__close')) { close(); return; }
      if (e.target.closest('.card-gallery-lightbox__nav--prev')) { show(index - 1); return; }
      if (e.target.closest('.card-gallery-lightbox__nav--next')) { show(index + 1); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    function isGalleryImg(img) {
      return img && img.tagName === 'IMG' && img.className.indexOf('card-gallery__img') !== -1;
    }

    // Erfolgreich geladen -> Kachel einblenden ("load" bubbelt nicht -> Capture).
    document.addEventListener('load', function (e) {
      if (!isGalleryImg(e.target)) return;
      var li = e.target.closest('.card-gallery__item');
      if (li) li.classList.add('is-ready');
    }, true);

    // Bild laedt nicht -> naechste Dateiendung probieren; sonst Kachel entfernen.
    document.addEventListener('error', function (e) {
      var img = e.target;
      if (!isGalleryImg(img)) return;

      var stem = img.getAttribute('data-cg-stem');
      var exts = (img.getAttribute('data-cg-exts') || '').split(',').filter(Boolean);
      var i = parseInt(img.getAttribute('data-cg-ext-i') || '0', 10);

      if (stem && i + 1 < exts.length) {
        i += 1;
        img.setAttribute('data-cg-ext-i', String(i));
        img.src = stem + '.' + exts[i] + '?width=500';
        var btn = img.closest('[data-cg-full]');
        if (btn) btn.setAttribute('data-cg-full', stem + '.' + exts[i] + '?width=1600');
        return;
      }

      var li = img.closest('.card-gallery__item');
      if (li) li.parentNode.removeChild(li);
    }, true);

    // Bereits fertige/gecachte Bilder behandeln, deren load/error-Event vor dem
    // Listener lag; plus Sicherheitsnetz, damit nie eine Kachel unsichtbar bleibt.
    function sweep() {
      var imgs = document.querySelectorAll('.card-gallery__img');
      for (var k = 0; k < imgs.length; k++) {
        var im = imgs[k];
        if (!im.complete) continue;
        if (im.naturalWidth > 0) {
          var li = im.closest('.card-gallery__item');
          if (li) li.classList.add('is-ready');
        } else {
          im.dispatchEvent(new Event('error'));
        }
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sweep);
    } else {
      sweep();
    }
    window.addEventListener('load', sweep);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-kartenliste-lorcana"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cardGalleryInit) return;
    window.__cardGalleryInit = true;

    var overlay = document.createElement('div');
    overlay.className = 'card-gallery-lightbox';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="card-gallery-lightbox__close" aria-label="Schliessen">&times;</button>' +
      '<button type="button" class="card-gallery-lightbox__nav card-gallery-lightbox__nav--prev" aria-label="Zurueck">&#8249;</button>' +
      '<figure class="card-gallery-lightbox__figure">' +
        '<img class="card-gallery-lightbox__img" src="" alt="">' +
        '<figcaption class="card-gallery-lightbox__caption"></figcaption>' +
      '</figure>' +
      '<button type="button" class="card-gallery-lightbox__nav card-gallery-lightbox__nav--next" aria-label="Weiter">&#8250;</button>';

    var imgEl, capEl, group = [], index = -1;

    function ready() {
      if (!document.body) { document.addEventListener('DOMContentLoaded', ready); return; }
      document.body.appendChild(overlay);
      imgEl = overlay.querySelector('.card-gallery-lightbox__img');
      capEl = overlay.querySelector('.card-gallery-lightbox__caption');
    }
    ready();

    function show(i) {
      if (!group.length) return;
      if (i < 0) i = group.length - 1;
      if (i >= group.length) i = 0;
      index = i;
      var el = group[i];
      imgEl.src = el.getAttribute('data-cg-full');
      imgEl.alt = el.getAttribute('data-cg-name') || '';
      capEl.textContent = el.getAttribute('data-cg-name') || '';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (imgEl) imgEl.src = '';
      group = [];
      index = -1;
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cg-full]');
      if (trigger) {
        e.preventDefault();
        var gallery = trigger.closest('.card-gallery');
        group = Array.prototype.slice.call(gallery.querySelectorAll('[data-cg-full]'));
        show(group.indexOf(trigger));
        return;
      }
      if (!overlay.classList.contains('is-open')) return;
      if (e.target === overlay || e.target.closest('.card-gallery-lightbox__close')) { close(); return; }
      if (e.target.closest('.card-gallery-lightbox__nav--prev')) { show(index - 1); return; }
      if (e.target.closest('.card-gallery-lightbox__nav--next')) { show(index + 1); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    function isGalleryImg(img) {
      return img && img.tagName === 'IMG' && img.className.indexOf('card-gallery__img') !== -1;
    }

    document.addEventListener('load', function (e) {
      if (!isGalleryImg(e.target)) return;
      var li = e.target.closest('.card-gallery__item');
      if (li) li.classList.add('is-ready');
    }, true);

    document.addEventListener('error', function (e) {
      var img = e.target;
      if (!isGalleryImg(img)) return;

      var stem = img.getAttribute('data-cg-stem');
      var exts = (img.getAttribute('data-cg-exts') || '').split(',').filter(Boolean);
      var i = parseInt(img.getAttribute('data-cg-ext-i') || '0', 10);

      if (stem && i + 1 < exts.length) {
        i += 1;
        img.setAttribute('data-cg-ext-i', String(i));
        img.src = stem + '.' + exts[i] + '?width=500';
        var btn = img.closest('[data-cg-full]');
        if (btn) btn.setAttribute('data-cg-full', stem + '.' + exts[i] + '?width=1600');
        return;
      }

      var li = img.closest('.card-gallery__item');
      if (li) li.parentNode.removeChild(li);
    }, true);

    function sweep() {
      var imgs = document.querySelectorAll('.card-gallery__img');
      for (var k = 0; k < imgs.length; k++) {
        var im = imgs[k];
        if (!im.complete) continue;
        if (im.naturalWidth > 0) {
          var li = im.closest('.card-gallery__item');
          if (li) li.classList.add('is-ready');
        } else {
          im.dispatchEvent(new Event('error'));
        }
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sweep);
    } else {
      sweep();
    }
    window.addEventListener('load', sweep);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-kartenliste"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cardGalleryInit) return;
    window.__cardGalleryInit = true;

    var overlay = document.createElement('div');
    overlay.className = 'card-gallery-lightbox';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="card-gallery-lightbox__close" aria-label="Schliessen">&times;</button>' +
      '<button type="button" class="card-gallery-lightbox__nav card-gallery-lightbox__nav--prev" aria-label="Zurueck">&#8249;</button>' +
      '<figure class="card-gallery-lightbox__figure">' +
        '<img class="card-gallery-lightbox__img" src="" alt="">' +
        '<figcaption class="card-gallery-lightbox__caption"></figcaption>' +
      '</figure>' +
      '<button type="button" class="card-gallery-lightbox__nav card-gallery-lightbox__nav--next" aria-label="Weiter">&#8250;</button>';

    var imgEl, capEl, group = [], index = -1;

    function ready() {
      if (!document.body) { document.addEventListener('DOMContentLoaded', ready); return; }
      document.body.appendChild(overlay);
      imgEl = overlay.querySelector('.card-gallery-lightbox__img');
      capEl = overlay.querySelector('.card-gallery-lightbox__caption');
    }
    ready();

    function show(i) {
      if (!group.length) return;
      if (i < 0) i = group.length - 1;
      if (i >= group.length) i = 0;
      index = i;
      var el = group[i];
      imgEl.src = el.getAttribute('data-cg-full');
      imgEl.alt = el.getAttribute('data-cg-name') || '';
      capEl.textContent = el.getAttribute('data-cg-name') || '';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (imgEl) imgEl.src = '';
      group = [];
      index = -1;
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cg-full]');
      if (trigger) {
        e.preventDefault();
        var gallery = trigger.closest('.card-gallery');
        group = Array.prototype.slice.call(gallery.querySelectorAll('[data-cg-full]'));
        show(group.indexOf(trigger));
        return;
      }
      if (!overlay.classList.contains('is-open')) return;
      if (e.target === overlay || e.target.closest('.card-gallery-lightbox__close')) { close(); return; }
      if (e.target.closest('.card-gallery-lightbox__nav--prev')) { show(index - 1); return; }
      if (e.target.closest('.card-gallery-lightbox__nav--next')) { show(index + 1); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    function isGalleryImg(img) {
      return img && img.tagName === 'IMG' && img.className.indexOf('card-gallery__img') !== -1;
    }

    document.addEventListener('load', function (e) {
      if (!isGalleryImg(e.target)) return;
      var li = e.target.closest('.card-gallery__item');
      if (li) li.classList.add('is-ready');
    }, true);

    document.addEventListener('error', function (e) {
      var img = e.target;
      if (!isGalleryImg(img)) return;

      var stem = img.getAttribute('data-cg-stem');
      var exts = (img.getAttribute('data-cg-exts') || '').split(',').filter(Boolean);
      var i = parseInt(img.getAttribute('data-cg-ext-i') || '0', 10);

      if (stem && i + 1 < exts.length) {
        i += 1;
        img.setAttribute('data-cg-ext-i', String(i));
        img.src = stem + '.' + exts[i] + '?width=500';
        var btn = img.closest('[data-cg-full]');
        if (btn) btn.setAttribute('data-cg-full', stem + '.' + exts[i] + '?width=1600');
        return;
      }

      var li = img.closest('.card-gallery__item');
      if (li) li.parentNode.removeChild(li);
    }, true);

    function sweep() {
      var imgs = document.querySelectorAll('.card-gallery__img');
      for (var k = 0; k < imgs.length; k++) {
        var im = imgs[k];
        if (!im.complete) continue;
        if (im.naturalWidth > 0) {
          var li = im.closest('.card-gallery__item');
          if (li) li.classList.add('is-ready');
        } else {
          im.dispatchEvent(new Event('error'));
        }
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sweep);
    } else {
      sweep();
    }
    window.addEventListener('load', sweep);
  })();

  } catch(e) { console.error(e); }
})();
})();
